import { FC, useEffect, useState, useCallback } from 'react'
import Stamp from '../../types/api/stamp'
import { useLazyGetStampsQuery } from '../../store/api/stamps-api'
import _ from 'lodash'
import { Num, Remove, Root } from './elements/elements'
import StampTubeLabelInfo from './stamp-tube-label-info'
import { DeleteOutlined } from '@ant-design/icons'

interface StampTubeLabelProps {
    onRemove?: () => void
    onChange?: (stamp: Stamp | null) => void
}

const StampTubeLabel: FC<StampTubeLabelProps> = ({ onRemove, onChange = () => {} }) => {
    const [number, setNumber] = useState<string>('')
    const [getStamps, { data }] = useLazyGetStampsQuery()
    const stamp: Stamp | null = number ? data?.data[0] || null : null

    useEffect(() => {
        onChange(stamp)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stamp])

    const search = useCallback(
        (value: string) => {
            _.debounce(() => {
                if (value) getStamps({ filters: { number: { $eq: value } } })
            }, 600)()
        },
        [getStamps]
    )

    useEffect(() => {
        search(number)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [number])

    return (
        <Root>
            <Num
                value={number}
                onChange={e => {
                    setNumber(e.target.value)
                }}
            />
            <StampTubeLabelInfo stamp={stamp} />
            {onRemove ? (
                <Remove
                    type={'primary'}
                    icon={<DeleteOutlined />}
                    shape={'circle'}
                    danger
                    onClick={onRemove}
                />
            ) : null}
        </Root>
    )
}

export default StampTubeLabel
